export const endpoints = {
    VIEW: "/strikes",
    GET_TASK: "/strikes/getTasks",
    DELETE: "/events/delete",
    EVENT_GET: "events/get",
    EVENT_DELETE: 'events/permission'
}